import React from 'react'
import classNames from 'classnames'
import { ImageProps } from '@toasttab/shared/src/interfaces/Interface.d'

const Image = ({
  classes,
  desktopLargeImage,
  fullBleed,
  imageAlt,
  imgClasses,
  lazyLoad = true,
  optimizedImages,
  pictureClasses,
  scaleHover = true,
  objectCover = true,
  title,
  url
}: ImageProps) => {
  const imageWrapperCss = classNames(classes, {
    'relative w-full p-0 overflow-hidden': objectCover,
    'md:transition-all md:duration-300 md:ease-out md:group-hover:scale-95':
      scaleHover,
    '-mx-4 md:mx-0': fullBleed,
    'lg-media': desktopLargeImage
  })

  const imageCss = classNames(imgClasses, {
    'object-cover h-full w-full': objectCover,
    'md:transition-all md:duration-300 md:ease-out scale-100 md:group-hover:scale-110':
      scaleHover,
    lazyload: lazyLoad
  })

  // There are valid uses cases for empty alt text
  // This, along with the type check below, will support explicitly passing an empty string when necessary
  // If the value is null, it will fall back to the image title
  imageAlt = imageAlt || imageAlt === '' ? imageAlt : null

  if (optimizedImages?.srcsetAvif) {
    return (
      <div className={imageWrapperCss} data-testid='Image-srcset'>
        <picture className={pictureClasses}>
          <source
            srcSet={optimizedImages.srcsetAvif}
            data-srcset={optimizedImages.srcsetAvif}
            data-sizes='auto'
            type='image/avif'
            title={title}
          />
          <source
            srcSet={url}
            data-srcset={url}
            data-sizes='auto'
            title={title}
          />
          <img
            alt={typeof imageAlt === 'string' ? imageAlt : title}
            className={imageCss}
            data-sizes='auto'
            data-src={optimizedImages.placeholderBox}
            data-srcset={optimizedImages.srcset}
            src={lazyLoad ? optimizedImages.placeholderBox : url}
          />
        </picture>
      </div>
    )
  }
  return (
    <div className={imageWrapperCss} data-testid='Image'>
      <picture>
        {optimizedImages?.srcAvif && (
          <source srcSet={optimizedImages.srcAvif} type='image/avif' />
        )}
        {objectCover && (
          <img
            alt={typeof imageAlt === 'string' ? imageAlt : title}
            className={imageCss}
            sizes='auto'
            src={url}
          />
        )}
        {!objectCover && (
          <img src={url} className={imageCss} alt={imageAlt || title} />
        )}
      </picture>
    </div>
  )
}

export default Image
